import { BrandTabs } from "entities/pages/types";
import { FC } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { RedRepairIcon } from "shared/theme/icons/RedRepairIcon";
import { StyledTab, StyledTabs } from "./styled";
import { getTabProps } from "./utils";

type TabsProps = {
  selectedTab: BrandTabs;
  setSelectedTab: (arg0: BrandTabs) => void;
  isMaintenanceMode?: boolean;
};

const Tabs: FC<TabsProps> = ({
  selectedTab,
  setSelectedTab,
  isMaintenanceMode,
}) => {
  const handleTabChange = (newTab: string) => {
    setSelectedTab(newTab as BrandTabs);
  };

  return (
    <StyledTabs
      value={selectedTab}
      onChange={(_, newValue) => handleTabChange(newValue)}
      TabIndicatorProps={{
        style: {
          backgroundColor: COLOR_PRIMARY_MAIN,
          height: 2,
        },
      }}
    >
      <StyledTab
        {...getTabProps(BrandTabs.Pages)}
        value={BrandTabs.Pages}
        disableRipple
        label="Pages"
      />
      <StyledTab
        {...getTabProps(BrandTabs.Settings)}
        value={BrandTabs.Settings}
        disableRipple
        label="Settings"
        icon={isMaintenanceMode ? <RedRepairIcon /> : ""}
        iconPosition="end"
      />
    </StyledTabs>
  );
};

export default Tabs;
